export default __webpack_public_path__ + "static/media/confirm.3d30565e.gif";